import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { type PiloteBackgroundCheckStatus } from '@onr/schema'
import dayjs from 'dayjs'

type Decision = PiloteBackgroundCheckStatus | null | undefined

export const useDecisionText = () => {
  const intl = useIntl()

  return useCallback(
    (decision: Decision) => {
      switch (decision) {
        case 'COMPLETE_ACCEPTANCE':
          return intl.formatMessage({ id: 'judicial.results.decision.accepted' })
        case 'PRELIMINARY_ACCEPTANCE':
          return intl.formatMessage({ id: 'judicial.results.decision.preliminaryAcceptance' })
        case 'ACCEPT_ESCORT':
          return intl.formatMessage({ id: 'judicial.results.decision.acceptEscort' })
        case 'ACCEPT_PARTNER':
          return intl.formatMessage({ id: 'judicial.results.decision.acceptPartner' })
        case 'COMPLETE_REFUSAL':
          return intl.formatMessage({ id: 'judicial.results.decision.completeRefusal' })
        default:
          return ''
      }
    },
    [intl]
  )
}

export const decisionTextColor =
  (sixMonthsAgo: dayjs.Dayjs) => (decision: Decision, lastDecisionDate: Date | null | undefined) => {
    const isRecent = lastDecisionDate && dayjs(lastDecisionDate).isAfter(sixMonthsAgo)

    switch (decision) {
      case 'COMPLETE_ACCEPTANCE':
      case 'PRELIMINARY_ACCEPTANCE':
        return isRecent ? 'text-green-500 font-bold' : 'text-black font-normal'
      case 'ACCEPT_ESCORT':
      case 'ACCEPT_PARTNER':
        return isRecent ? 'text-blue-500 font-bold' : 'text-black font-normal'
      case 'COMPLETE_REFUSAL':
        return isRecent ? 'text-red-700 font-bold' : 'text-red-700 font-normal'
      default:
        return 'text-gray-700'
    }
  }
